import React from "react"
import { generalStyles as gs } from "../styles/styles"
import { COLORS } from "../../utilities/Constants"

// Pastille de solde des cartes « Transactions », partagée par les 3 fiches
// (atelier / location / dépannage) — même libellé, mêmes couleurs partout.
// Tolérance au centime : les restes sont des flottants (arrondis différents
// selon la fiche), un test `=== 0` laissait passer des 0.004 en « impayé ».
export const isSolde = (reste) => Math.abs(parseFloat(reste) || 0) < 0.01

const SoldeBadge = ({ reste, style = null }) => {
	const solde = isSolde(reste)
	return (
		<div
			style={{
				...gs.badge(
					solde ? COLORS.success : COLORS.gold,
					solde ? COLORS.successLight : COLORS.warningLight,
				),
				...style,
			}}
		>
			{solde ? "Soldé" : `Reste à payer : ${reste} CHF`}
		</div>
	)
}

export default SoldeBadge
